import type { TaskBodyProps } from './index';
import { DesignPlanHistory } from './DesignPlanHistory';
import { DesignPatientInfo } from './submit-design/DesignPatientInfo';
import { RefinementRdiPanel } from './submit-design/RefinementRdiPanel';

// Ref-7 "Submit for manufacturing" — mirrors the initial submit-for-manufacturing
// step, but shows the RDI (not the Dx report), and the design submissions are
// scoped to the current refinement via the case's phaseEnteredAt.
export function RefinementSubmitManufacturingTask({ workCase: c }: TaskBodyProps) {
    return (
        <div className="flex-1 min-h-0 flex flex-col px-4 pt-3 pb-3">
            <div className="flex-1 min-h-0 flex gap-3">
                {/* LEFT — submitted refinement design instructions (this refinement only) */}
                <div className="flex-[6] min-w-0 flex flex-col">
                    <DesignPlanHistory
                        patientId={c.id}
                        title="Submitted refinement instructions"
                        emptyText="No refinement design instructions submitted yet."
                        submitType="submit-refinement-for-design"
                        preApprovedType="refinement-design-pre-approved"
                        since={c.phaseEnteredAt}
                    />
                </div>

                {/* RIGHT — patient info over the RDI (in place of the Dx report) */}
                <div className="flex-[4] min-w-0 min-h-0 flex flex-col gap-3">
                    <div className="flex-[4] min-h-0">
                        <DesignPatientInfo patientId={c.id} />
                    </div>
                    <div className="flex-[6] min-h-0">
                        <RefinementRdiPanel patientId={c.id} since={c.phaseEnteredAt} />
                    </div>
                </div>
            </div>
        </div>
    );
}
